<script>
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";

export default {
  name: "app",
  computed: {
    ...authComputed,
  },
  page: {
    // All sub component titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title("demo") : title;
      return title
        ? `${appConfig.title} | ${title.toLowerCase()}`
        : appConfig.title;
    },
  },
  methods: {
    handleIcon() {
      if (this.user !== null || this.user !== undefined) {
        const faviconIcon = document.getElementById("favicon");
        if (
          this.hotel.favicon_icon !== undefined ||
          this.hotel.favicon_icon !== null ||
          this.hotel.favicon_icon !== ""
        ) {
          faviconIcon.href = this.hotel.favicon_icon;
        }
      }
    },
  },
};
</script>

<template>
  <component :is="$route.meta.layout || 'div'">
    <div id="app">
      <RouterView />
    </div>
  </component>
</template>

<style>
:root {
  --template-theme: #47afff;
  --template-theme-border: #ffffff;
  --template-theme-font: #ffffff;
  --template-theme-icon: #ffffff;
  --template-title-bg: #ffffff;
  --template-title-font: #ffffff;
  --template-menu-bg: #ffffff;
  --template-menu-font: #ffffff;
  --template-btn-bg: #ffffff;
  --template-btn-font: #ffffff;
  --template-btn-border: #ffffff;
}

.pagination {
  float: right !important;
}
.avatar-md {
  height: 2.25rem;
  width: 2.25rem;
}
.dropdown-toggle {
  display: flex;
  align-items: center;
}
</style>
